"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Stars = _ref => {
  let {
    className,
    style,
    number = 200
  } = _ref;
  _react.default.useEffect(() => {
    // randomize stars;
    var randSize, randX, randY;
    // document.getElementById("space");
    var wrapper = document.getElementById('galaxy-wrapper');
    var stars = document.getElementById('stars');
    function placeStar() {
      // $('.star').remove();  
      for (var i = 0; i < number; i++) {
        randSize = Math.floor(Math.random() * 5);
        randX = Math.floor(Math.random() * window.innerWidth);
        randY = Math.floor(Math.random() * window.innerHeight);
        var star = '<span class="star2" style="width:' + randSize + 'px;height:' + randSize + 'px;top:' + randY + 'px;left:' + randX + 'px;animation: blink ' + randSize + 's infinite;"></span>';
        wrapper.insertAdjacentHTML('afterbegin', star);
        stars.insertAdjacentHTML('afterbegin', star);
      }
    }
    placeStar();
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "galaxy-wrapper",
    className: className,
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "stars"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "shooting-stars-left"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "shooting-stars-right"
  }));
};
var _default = exports.default = Stars;